import React from 'react';
import './SellerJourney.css';

export default function SellerJourney() {
  const steps = [
  {
    id: 'step-1',
    title: 'Create',
    text: 'Register in just 10 mins with valid GST, address, & bank details',
    svg: (
      <img src="https://static-assets-web.flixcart.com/fk-sp-static/images/create-icon.svg" alt="Create" className="journey-svg" />
    )
  },
  {
    id: 'step-2',
    title: 'List',
    text: 'List your products (min 1 no.) that you want to sell on Haatza.',
    svg: (
      <img src="https://static-assets-web.flixcart.com/fk-sp-static/images/prelogin/icons/Group_2_1.svg" alt="List" className="journey-svg" />
    )
  },
  {
    id: 'step-3',
    title: 'Orders',
    text: 'Receive orders from over 45 crore+ Haatza customers.',
    svg: (
      <img src="https://static-assets-web.flixcart.com/fk-sp-static/images/orders-icon.svg" alt="Orders" className="journey-svg" />
    )
  },
  {
    id: 'step-4',
    title: 'Shipment',
    text: 'Haatza ensures stress free delivery of your products',
    svg: (
      <img src="https://static-assets-web.flixcart.com/fk-sp-static/images/shipment-icon.svg" alt="Shipment" className="journey-svg" />
    )
  },
  {
    id: 'step-5',
    title: 'Payment',
    text: 'Receive payment 7 days* from the date of dispatch of your order',
    svg: (
      <img src="https://static-assets-web.flixcart.com/fk-sp-static/images/payment-icon.svg" alt="Payment" className="journey-svg" />
    )
  }
];
  return (
    <section className="seller-journey-section section-padding" id="journey">
      <div className="container">
        <div className="journey-header">
          <h2 className="journey-title">
            <span style={{ color: '#007BFF' }}>Your Journey</span> <span style={{ color: '#0f172a' }}>on Haatza</span>
          </h2>
          <p className="journey-subtitle">
            Starting your online business with Haatza is easy. 5 lakh+ sellers trust Haatza with their business.
          </p>
        </div>

        <div className="journey-steps-grid">
          {steps.map((step, idx) => (
            <div key={step.id} className="journey-step-card">
              <div className="step-svg-wrapper">
                {step.svg}
              </div>
              <h3 className="step-card-title">
  {step.title}
</h3>
              <p className="step-card-text">{step.text}</p>
            </div>
          ))}
        </div>

        <div className="journey-cta">
          <a 
            href="https://www.haatzaseller.com/_files/ugd/73d0ef_0534594a1d3d4396a5e40e7a2c65deea.pdf" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="journey-download-link"
          >
            <button className="journey-download-btn">Download Launch Kit</button>
          </a>
        </div>
      </div>
    </section>
  );
}
